// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"1fd22c46","143":"3bda3a77","192":"da7156c8","295":"b7866c1e","349":"d086a82c","351":"65e3faea","592":"3cf92ea5","655":"baf750d6","813":"46c824f1","866":"d8528eee","927":"28ca6f2a","963":"4ea9dfb1"}[chunkId] + ".chunk.js";
};